"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let JobHandlerControl = class JobHandlerControl extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getPoller(...args) {
        if (!this._poller) {
            this._poller = this.$fn.poller({
                id: 'Job',
                callback: this.checkJob.bind(this),
                interval: this.pollingInterval,
            });
        }
        return this._poller;
    }
    beforeDestroy(...args) {
        {
            {
                this._poller && this._poller.stop();
            }
        }
    }
    checkJob(...args) {
        if (!this.jobData) {
            return false;
        }
        const status = this.status;
        if (status && this.status != status) {
            console.log(`checkJob: jobStatus changed from ${this.status} to ${status}`, this.jobPoller);
            this.$emit(status);
            this.status = status;
        }
        if (status !== 'pending' && status !== 'running') {
            console.log(`checkJob: JobStatus is ${status}, stop polling.`, this.jobPoller);
            this.jobPoller.stop();
            this.$emit('success');
            return;
        }
        console.log('checkJob: fetch', this.jobPoller);
        return this.$fn
            .fetch('read_job_info', { parameters: { id: this.jobData.id } })
            .then(data => { this.onJobInfoReceived(data); });
    }
    loadJob(...args) {
        return this.$fn
            .fetch('read_a_job', { parameters: { id: this.jobData.id } })
            .then(data => this.onJobReceived(data))
            .then(() => this.maybeStopPoll())
            .catch(error => this.handleError(error));
    }
    onJobInfoReceived(...args) {
        const [{ status, progress }] = args;
        this.progress = progress;
        if (status && this.status != status) {
            this.setData('status', status);
            this.$emit(status);
            if (status === 'completed') {
                this.$emit('success');
            }
            if (status !== 'running') {
                return this.loadJob();
            }
        }
    }
    onJobReceived(...args) {
        const [resource] = args;
        this.setData('jobData', resource);
        this.setData('status', resource.status);
        this.setData('progress', resource.progress);
    }
    onSubmit(...args) {
        const val = _.isFunction(this.payload) ? this.payload() : this.payload;
        if (this.isRunning) {
            return;
        }
        Promise
            .resolve(val)
            .then(payload => {
            if (!payload || payload.cancel) {
                return;
            }
            this.$fn.crud('a_job')
                .create(payload, { parameters: { job_type: this.jobType } })
                .then(resource => this.onJobReceived(resource))
                .then(() => this.maybeStartPoll())
                .catch(error => this.handleError(error));
        })
            .catch(error => this.handleError(error));
    }
    maybeStartPoll(...args) {
        if (['completed', 'failed', 'cancelled', 'deleted'].indexOf(this.status) > -1) {
            return;
        }
        if (!this.jobPoller.isRunning) {
            return this.jobPoller.start();
        }
    }
    maybeStopPoll(...args) {
        if (['pending', 'running'].indexOf(this.status) > -1) {
            return;
        }
        if (this.jobPoller.isRunning) {
            return this.jobPoller.stop();
            if (this.status == 'completed') {
                this.$emit('success');
            }
        }
    }
    block;
    onBlock(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("block");
    }
    jobType;
    onJob_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("jobType");
    }
    text;
    onText(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("text");
    }
    loadCurrent;
    onLoad_current(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("loadCurrent");
    }
    payload;
    onPayload(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("payload");
    }
    jobId;
    onJob_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("jobId");
    }
    icon;
    onIcon(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("icon");
    }
    variant;
    onVariant(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("variant");
    }
    disabled;
    onDisabled(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("disabled");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tooltip;
    onTooltip(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("tooltip");
    }
    pollingInterval;
    onPolling_interval(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("pollingInterval");
    }
    messages;
    jobData;
    async $$load_jobData() {
        return this.loadCurrent
            ? this.$fn.fetch('read_a_job', { parameters: { id: this.jobID || 'current', job_type: this.jobType }, asResource: true })
            : null;
    }
    jobPoller;
    async $$load_jobPoller() {
        return this.getPoller();
    }
    status;
    progress;
    ux;
    dataMembers = ['messages', 'jobData', 'jobPoller', 'status', 'progress', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    showJobTooltip: this.$fn.pgettext("JobHandler|Command", "Open job details"),
                    reloadJobData: this.$fn.pgettext("JobHandler|Command", "Reload job status"),
                },
                jobData: null,
                jobPoller: null,
                status: null,
                progress: null,
                ux: null,
            },
        };
    }
    get isRunning() {
        if (this.loaded) {
            return this.status === 'running';
        }
        return null;
    }
    get isPending() {
        if (this.loaded) {
            return this.status === 'pending';
        }
        return null;
    }
    get spinning() {
        if (this.loaded) {
            return this.isRunning || this.isPending || (this.actions && this.actions.reloadJobData && this.actions.reloadJobData.isRunning);
        }
        return null;
    }
    async act_7315092382398562_script_7762_getActionArgs_value($event) {
        this.onSubmit();
    }
    async act_7315092382398562_script_7762_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_7762_getActionArgs_value($event),
        };
    }
    async act_7315092382398562_script_7762_getWhen($event) {
        return !this.disabled;
    }
    async evh_7315092382398562_clickPreventStop(event, scope) {
        return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_96700093353179_script_7764_getActionArgs_value($event) {
        this.onSubmit();
    }
    async act_96700093353179_script_7764_getActionArgs($event) {
        return {
            value: () => this.act_96700093353179_script_7764_getActionArgs_value($event),
        };
    }
    async act_96700093353179_script_7764_getWhen($event) {
        return !this.disabled;
    }
    async evh_96700093353179_clickPreventStop(event, scope) {
        return await this.actions.evh_96700093353179_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_96700093353179_script_7766_getActionArgs_value($event) {
        $event.stop();
    }
    async act_96700093353179_script_7766_getActionArgs($event) {
        return {
            value: () => this.act_96700093353179_script_7766_getActionArgs_value($event),
        };
    }
    async evh_96700093353179_bvDropdownHide(event, scope) {
        return await this.actions.evh_96700093353179_bvDropdownHide.executeFromDOM(this, event, scope);
    }
    async act_96700093353179_script_7768_getActionArgs_value($event) {
        console.log($event);
    }
    async act_96700093353179_script_7768_getActionArgs($event) {
        return {
            value: () => this.act_96700093353179_script_7768_getActionArgs_value($event),
        };
    }
    async evh_96700093353179_bvDropdownShow(event, scope) {
        return await this.actions.evh_96700093353179_bvDropdownShow.executeFromDOM(this, event, scope);
    }
    async act_302930856768608_showModal_7770_getActionArgs($event) {
        return {
            name: "Job",
            props: {
                oid: this.jobData.id,
            },
        };
    }
    async evh_302930856768608_clickPreventStop(event, scope) {
        return await this.actions.evh_302930856768608_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_939987670462915_setData_7774_getActionArgs($event) {
        return {
            path: "jobData",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_939987670462915_setData_7774_getWhen($event) {
        return $event.data.response.data;
    }
    async act_939987670462915_request_7772_getActionArgs($event) {
        return {
            operation: "read_a_job",
            parameters: {
                id: this.jobData.id,
            },
        };
    }
    async evh_939987670462915_clickPreventStop(event, scope) {
        return await this.actions.evh_939987670462915_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_script_7762 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_7762_getActionArgs,
            when: this.act_7315092382398562_script_7762_getWhen,
            displayName: "submit",
            events: [],
        });
        const evh_7315092382398562_clickPreventStop_7761 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_7762,
            event: "click.prevent.stop",
            displayName: "submit",
        });
        const evh_7315092382398562_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_clickPreventStop_7761],
        });
        const act_96700093353179_script_7764 = new core_1.actions.ScriptAction({
            actionArgs: this.act_96700093353179_script_7764_getActionArgs,
            when: this.act_96700093353179_script_7764_getWhen,
            displayName: "submit",
            events: [],
        });
        const evh_96700093353179_clickPreventStop_7763 = new core_1.actions.EventHandlerImpl({
            action: act_96700093353179_script_7764,
            event: "click.prevent.stop",
            displayName: "submit",
        });
        const evh_96700093353179_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_96700093353179_clickPreventStop_7763],
        });
        const act_96700093353179_script_7766 = new core_1.actions.ScriptAction({
            actionArgs: this.act_96700093353179_script_7766_getActionArgs,
            events: [],
        });
        const evh_96700093353179_bvDropdownHide_7765 = new core_1.actions.EventHandlerImpl({
            action: act_96700093353179_script_7766,
            event: "bv::dropdown::hide",
            displayName: "script",
        });
        const evh_96700093353179_bvDropdownHide = new core_1.actions.EventHandlerGroup({
            handlers: [evh_96700093353179_bvDropdownHide_7765],
        });
        const act_96700093353179_script_7768 = new core_1.actions.ScriptAction({
            actionArgs: this.act_96700093353179_script_7768_getActionArgs,
            events: [],
        });
        const evh_96700093353179_bvDropdownShow_7767 = new core_1.actions.EventHandlerImpl({
            action: act_96700093353179_script_7768,
            event: "bv::dropdown::show",
            displayName: "script",
        });
        const evh_96700093353179_bvDropdownShow = new core_1.actions.EventHandlerGroup({
            handlers: [evh_96700093353179_bvDropdownShow_7767],
        });
        const act_302930856768608_showModal_7770 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_302930856768608_showModal_7770_getActionArgs,
            displayName: "showJob",
            events: [],
        });
        const evh_302930856768608_clickPreventStop_7769 = new core_1.actions.EventHandlerImpl({
            action: act_302930856768608_showModal_7770,
            event: "click.prevent.stop",
            displayName: "showJob",
        });
        const evh_302930856768608_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_302930856768608_clickPreventStop_7769],
        });
        const act_939987670462915_setData_7774 = new core_1.actions.SetDataAction({
            actionArgs: this.act_939987670462915_setData_7774_getActionArgs,
            when: this.act_939987670462915_setData_7774_getWhen,
            events: [],
        });
        const evh_939987670462915_success_7773 = new core_1.actions.EventHandlerImpl({
            action: act_939987670462915_setData_7774,
            event: "success",
            displayName: "setData",
        });
        const act_939987670462915_request_7772 = new core_1.actions.RequestAction({
            actionArgs: this.act_939987670462915_request_7772_getActionArgs,
            displayName: "reloadJobData",
            events: [evh_939987670462915_success_7773],
        });
        const evh_939987670462915_clickPreventStop_7771 = new core_1.actions.EventHandlerImpl({
            action: act_939987670462915_request_7772,
            event: "click.prevent.stop",
            displayName: "reloadJobData",
        });
        const evh_939987670462915_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_939987670462915_clickPreventStop_7771],
        });
        return {
            act_7315092382398562_script_7762,
            evh_7315092382398562_clickPreventStop_7761,
            evh_7315092382398562_clickPreventStop,
            act_96700093353179_script_7764,
            evh_96700093353179_clickPreventStop_7763,
            evh_96700093353179_clickPreventStop,
            act_96700093353179_script_7766,
            evh_96700093353179_bvDropdownHide_7765,
            evh_96700093353179_bvDropdownHide,
            act_96700093353179_script_7768,
            evh_96700093353179_bvDropdownShow_7767,
            evh_96700093353179_bvDropdownShow,
            act_302930856768608_showModal_7770,
            evh_302930856768608_clickPreventStop_7769,
            evh_302930856768608_clickPreventStop,
            act_939987670462915_setData_7774,
            evh_939987670462915_success_7773,
            act_939987670462915_request_7772,
            evh_939987670462915_clickPreventStop_7771,
            evh_939987670462915_clickPreventStop,
            submit: act_96700093353179_script_7764,
            showJob: act_302930856768608_showModal_7770,
            reloadJobData: act_939987670462915_request_7772,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], JobHandlerControl.prototype, "block", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('block'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onBlock", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], JobHandlerControl.prototype, "jobType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('jobType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onJob_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], JobHandlerControl.prototype, "text", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('text'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onText", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], JobHandlerControl.prototype, "loadCurrent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('loadCurrent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onLoad_current", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
    }),
    __metadata("design:type", typeof (_a = typeof Function !== "undefined" && Function) === "function" ? _a : Object)
], JobHandlerControl.prototype, "payload", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('payload'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onPayload", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], JobHandlerControl.prototype, "jobId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('jobId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onJob_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], JobHandlerControl.prototype, "icon", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('icon'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onIcon", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "light",
    }),
    __metadata("design:type", String)
], JobHandlerControl.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('variant'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onVariant", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], JobHandlerControl.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onDisabled", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], JobHandlerControl.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onSize", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], JobHandlerControl.prototype, "tooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('tooltip'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onTooltip", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Number,
        default: 1000,
    }),
    __metadata("design:type", Number)
], JobHandlerControl.prototype, "pollingInterval", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('pollingInterval'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobHandlerControl.prototype, "onPolling_interval", null);
JobHandlerControl = __decorate([
    (0, vue_property_decorator_1.Component)()
], JobHandlerControl);
exports.default = JobHandlerControl;
vue_property_decorator_1.Vue.component("JobHandlerControl", JobHandlerControl);
